<template>
  <b-modal
    id="modal-newProject"
    title="Dodaj nov projekt"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="dark"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="newProject">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Izberi naročnika">
                <multiselect
                  required
                  v-model="form.company"
                  :options="companies"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Izberi"
                  label="company"
                  track-by="id"
                  :preselect-first="false"
                  :allow-empty="false"
                >
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                  >
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} izbranih</span
                    >
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="6">
              <b-form-group description="Naziv projekta">
                <b-input
                  required
                  size="md"
                  v-model="form.title"
                  type="text"
                  placeholder="Projekt XYZ"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group description="Naslov, ki se pokaže nad karticami">
                <b-input
                  required
                  size="md"
                  v-model="form.matchup_title"
                  type="text"
                  placeholder="Izberite favorita"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="6">
              <b-form-group description="Sekvenca">
                <b-input
                  size="md"
                  required
                  v-model="form.questions_sequence"
                  type="number"
                  placeholder="20"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group description="Prikazanih kartic">
                <b-input
                  size="md"
                  required
                  v-model="form.matchup_length"
                  type="number"
                  placeholder="2"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12">
              <h6 class="mb-0">Uvodni tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže, ko uporabnik izpolnjuje svoje podatke
              </small>
              <TipTap
                v-bind:richdata="form.description"
                @htmlChange="descriptionChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Intro tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže na uvodni strani pred karticami</small
              >
              <TipTap
                v-bind:richdata="form.intro_text"
                @htmlChange="introChanged"
              />
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-newProject')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Ustvari nov projekt
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Multiselect from "vue-multiselect";
import TipTap from "@/components/tools/TipTap.vue";

Vue.component("multiselect", Multiselect);

export default {
  components: {
    Multiselect,
    TipTap,
  },
  data() {
    return {
      isSending: false,
      form: {
        title: "",
        // TODO: PRESELECT COMPANY
        company: "",
        description: "",
        matchup_length: 2,
        questions_sequence: 10,
        intro_text: "",
        matchup_title: "Izberite favorita",
      },
      companies: [],
    };
  },
  mounted: function() {
    this.fetchCompanies();
  },
  methods: {
    fetchCompanies: function() {
      this.$store
        .dispatch("api/fetchClients")
        .then(() => {
          this.companies = this.$store.getters["api/getClients"];
        })
        .catch((err) => console.log(err));
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      let submitData = this.form;
      submitData.company_id = this.form.company.id;

      return new Promise((resolve, reject) => {
        axios({
          url: this.$store.state.login.url + "/api/dashboard/projects/new",
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(submitData),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-newProject");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    introChanged(value) {
      this.form.intro_text = value;
    },
    descriptionChanged(value) {
      this.form.description = value;
    },
  },
};
</script>
